const getBqIntegration = async ({ params, api }) => {
  return await api(`bqIntegration/${params.id}`)
    .then((res) => {
      return Promise.resolve({ data: res });
    })
};

export default getBqIntegration;
